<template lang="pug">
	#dadosImovel
		el-row.tela(v-if="!done")
			loading-icon.spinner(:title="''", :height="'150'", :width="'150'")

		div(v-if="done")
			mixin status-car()

				.el-status.el.el-status-mid.color-blue(v-if='imovel.condicaoInscricao.codCondicao === "EA" || imovel.condicaoInscricao.codCondicao === "EAA"')
					span {{imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18 ? imovel.condicaoInscricao.nomCondicao.slice(0,15) + '...' : imovel.condicaoInscricao.nomCondicao}}

				.el-status.el.el-status-mid.color-orange(v-if='imovel.condicaoInscricao.codCondicao === "AARA" || imovel.condicaoInscricao.codCondicao === "RAA" || imovel.condicaoInscricao.codCondicao === "AA"')
					span {{imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18 ? imovel.condicaoInscricao.nomCondicao.slice(0,15) + '...' : imovel.condicaoInscricao.nomCondicao}}

				.el-status.el.el-status-mid.color-silver(v-if='imovel.condicaoInscricao.codCondicao != "AARA" && imovel.condicaoInscricao.codCondicao != "RAA" && imovel.condicaoInscricao.codCondicao != "AA" && imovel.condicaoInscricao.codCondicao != "EA" && imovel.condicaoInscricao.codCondicao != "EAA"')
					span {{imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18 ? imovel.condicaoInscricao.nomCondicao.slice(0,15) + '...' : imovel.condicaoInscricao.nomCondicao}}

			.card-header
				el-row.voltar.color-green
					a(@click="goToResultadosQuery($route.query.codigoPesquisa)")
						el-col(:sm='1', :md='1' :lg='1')
							arrow-left-icon(:title="''", :width="'20'", :height="'20'")
						el-col(:sm='1', :md='1' :lg='1')
							span Voltar

				el-row
					el-col(:sm='24', :md='9' :lg='9')
						span.codigo-imovel {{imovel.codigo}}
						el-row
							el-col(:sm='24', :md='24' :lg='24')
								span.nome-imovel {{imovel.nome}}
					el-col(:sm='8', :md='5' :lg='5')
						.projetos PRA
						el-row
							el-col(:sm='24', :md='24' :lg='24')
								div(v-if="imovel.regularidade.nome.length <= 25")
									el-tag {{imovel.regularidade.nome}}
								el-tooltip.item(v-if="imovel.regularidade.nome.length > 38", effect='dark', :content='imovel.regularidade.nome', placement='top')
									el-tag {{imovel.regularidade.nome.slice(0,35) + '...'}}

					el-col(:sm='16', :md='10' :lg='10')
						.projetos CAR
						el-row
							el-col(:xs='8', :sm='8', :md='7' :lg='6')
								div(v-if='imovel.restricoes.total === 0')
									.el-status.el-status-one Sem Restrições
								div(v-if='imovel.restricoes.total === 1')
									.el-status.el-status-one.color-red 1 Restrição
								div(v-if='imovel.restricoes.total > 1')
									.el-status.el-status-one.color-red {{imovel.restricoes.total}} Restrições

							el-col(:xs='10', :sm='8', :md='12' :lg='8')
								el-tooltip.item(v-if="imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length > 18", effect='dark', :content='imovel.condicaoInscricao.nomCondicao', placement='top')
									+status-car
								div(v-if="imovel.condicaoInscricao && imovel.condicaoInscricao.nomCondicao.length <= 18")
									+status-car

							el-col(:xs='4', :sm='6', :md='5' :lg='6')
								.el-status.el.el-status-last
									div(v-if="imovel.statusImovel== 'AT'").color-green Ativo
									div(v-if="imovel.statusImovel== 'PE'").color-red Pendente
			.main-container
				el-row
					el-col(:sm='20', :md='20' :lg='22').title
						span Dados do imóvel
					el-col(:sm='4', :md='4' :lg='2').text-align-right
						el-button(v-on:click="gerarPdf()" v-loading="tableDataLoading").loading
							div(v-if="!loading")
								printer-icon(:title="''")
								span.imprimir Imprimir
							div(v-if="loading")
								loading-icon.spinner(:title="''")
				.card-info-imovel.nao-clicavel
					el-row.margin-values-labels
						el-col(:sm='12', :md='12' :lg='10').labels Número do CAR
							el-row.margin-top-5
								el-col.values {{imovel.codigo}}

						el-col(:sm='8', :md='8' :lg='10').labels Nome do empreendimento
							el-row.margin-top-5
								el-col.values {{imovel.nome}}

						el-col(:sm='4', :md='4' :lg='4').labels Município
							el-row.margin-top-5
								el-col.values {{imovel.municipio.nome}} / PA
					el-row
						el-col(:sm='12', :md='12' :lg='10').labels Proprietários
							el-row.margin-top-5
								el-col.values(v-if="!todosProprietarios && proprietarios.length === 1") {{proprietarios[0]}}
								el-col.values(v-if="!todosProprietarios && proprietarios.length === 2") {{proprietarios[0] + ',' + proprietarios[1]}}
								el-col.values(v-if="!todosProprietarios && proprietarios.length > 2") {{proprietarios[0] + ',' + proprietarios[1]}}
									el-button.expand(v-on:click="todosProprietarios = true") {{ "Mais " + (proprietarios.length - 2) }}
								el-col.values(v-if="todosProprietarios") {{proprietarios.toString()}}
									el-button.expand(v-on:click="todosProprietarios = false") {{ "Menos " + (proprietarios.length - 2) }}

						el-col(:sm='8', :md='8' :lg='10').labels Área (ha)
							el-row.margin-top-5
								el-col.values {{imovel.area}}

						el-col(:sm='4', :md='4' :lg='4').labels Módulos fiscais
							el-row.margin-top-5
								el-col.values {{imovel.moduloFiscal}}

				#restricoes
					mixin restricoes-car(label, model, restricao, origem)

						el-collapse.collapse-restricoes(v-if="imovel.restricoes." + model + " > 0")
							el-collapse-item(name='1').el-collapse-item-restricoes
								template(slot='title')
									el-row
										el-col(:xs='2', :sm='2', :md='2' :lg='1')
											.el-status-restricao.el-statu-orange(v-if="imovel.restricoes." + model + "> 0")
												exclamation-icon(:title="''", :width="'21'", :height="'21'")
											.el-status-restricao.el-statu-green(v-if="imovel.restricoes." + model + " == 0")
												check-icon(:title="''", :width="'21'", :height="'21'")
										el-col(:xs='10', :sm='10', :md='6' :lg='4').ajuste-header
											p=label
										el-col(:xs='3', :sm='10', :md='4' :lg='4', v-if="imovel.restricoes." + model + " > 0")
											el-tag.el-total-restricao="Área total de conflito: {{imovel.restricoes." + model + ".toFixed(4)}} ha"
								div
									el-table(:data="imovel.restricoes." + restricao + "", style='width: 100%; padding-left: 1%;  padding-right: 1%', :row-class-name="checkRestricao")
										if origem
											el-table-column(label='Origem' width="350")
												template(slot-scope="scope")
													span {{scope.row.nomeOrigem}}
													span(v-if='scope.row.restricao')  - {{scope.row.restricao.nome}}
										if (restricao !== 'restricaoAreaEmbargada')
											el-table-column(prop="descricao", label='Descrição', show-overflow-tooltip)
												template(slot-scope="scope")
													span(v-if="scope.row.descricao.length > 0 ") {{scope.row.descricao}}
													span(v-if="scope.row.descricao.length === 0 ") Sem descrição
										else
											el-table-column(prop="descricaoTooltip", label='Descrição', show-overflow-tooltip)
												template(slot-scope="scope")
													span(v-if="scope.row.descricaoTooltip.length > 0") {{scope.row.descricaoTooltip}}
													span(v-if="scope.row.descricaoTooltip.length === 0") Sem descrição
										el-table-column(prop='areaConflito', label='Área (ha) de conflito')
											template(slot-scope="scope")
												span(v-if="scope.row.areaConflito > 0") {{scope.row.areaConflito}}
												span(v-if="(scope.row.areaConflito == 0)") Sem restrição
										el-table-column(prop='percentual', label='Percentual da área do imóvel (%)')
											template(slot-scope="scope")
												span(v-if="scope.row.percentual > 0 ") {{scope.row.percentual}}
												span(v-if="(scope.row.percentual === 0)") Sem restrição

						div(v-if="imovel.restricoes." + model + " == 0").el-collapse.collapse-restricoes
							div.el-collapse-item.el-collapse-item-restricoes
								div.el-collapse-item__header.nao-clicavel
									el-row
										el-col(:xs='2', :sm='2', :md='2' :lg='1')
											.el-status-restricao.el-statu-green
												check-icon(:title="''", :width="'21'", :height="'21'")
										el-col(:xs='10', :sm='10', :md='10' :lg='8').ajuste-header
											p=label

					el-row
						el-col.title
							span Mapa de comparação

					Mapa(:imovel="imovel" :idMapa="mapa1" ref="mapaPrincipal" v-loading="tableDataLoading")
					.mapaPdf
						Mapa(:imovel="imovel" :idMapa="mapa2" ref="mapaPdf")

					el-row
						el-col.title
							span Restrições Ambientais

					+restricoes-car('Assentamentos', 'totalAssentamento', 'restricaoAssentamento', false)

					+restricoes-car('Unidades de Conservação', 'totalUnidadeConservacao', 'restricaoUnidadeConservacao', false)

					+restricoes-car('Terras Indígenas', 'totalTerraIndigena', 'restricaoTerraIndigena', false)

					+restricoes-car('Outros Imóveis Rurais', 'totalSobreposicao', 'restricaoOutrosImoveisRurais', false)

					+restricoes-car('Áreas embargadas', 'totalAreasEmbargadas', 'restricaoAreaEmbargada', true)

				#areas-regularizacao
					el-row.title.title-areas-regularizadas
						el-col.ajuste-title(:sm='24', :md='15' :lg='9')
							span Descrição das áreas a serem regularizadas
						el-col(:sm='9', :md='9' :lg='9').margin-top-5
							h6 Status :
								el-tag {{imovel.regularidade.nome}}
					el-row.table-footer(v-loading="tableDataLoading")
						el-col
							el-table.table-regularizacao(:data='tableData', style='width: 100%', border)
								el-table-column(prop='nome', label='Nome', width="350", class-name="nome")
								el-table-column(prop='areaConsolidada', label='Área Consolidada (Antes de 2008)', class-name="areas")
								el-table-column(prop='areaAntropizada', label='Área Antropizada (Pós 2008)', class-name="areas")
								el-table-column(prop='total', label='Total', class-name="areas")

</template>

<script>

import ExclamationIcon from 'vue-material-design-icons-size/Exclamation.vue'
import CheckIcon from 'vue-material-design-icons-size/Check.vue'
import ArrowLeftIcon from 'vue-material-design-icons-size/ArrowLeft.vue'
import PrinterIcon from 'vue-material-design-icons-size/Printer.vue'
import RouterMixin from '@/utils/mixins/RouterMixin'
import ImoveisService from '../../utils/services/imoveis.service'
import Mapa from '../elements/Mapa'
import leafletImage from 'leaflet-image'
import LoadingIcon from 'vue-material-design-icons-size/Loading'
import Vue from 'vue'

export default {

	components: {
		LoadingIcon,
		Mapa,
		ExclamationIcon,
		CheckIcon,
		ArrowLeftIcon,
		PrinterIcon,
		ImoveisService
	},

	mixins: [RouterMixin],

	data() {

		return {
			imovel: [],
			promicePdf: undefined,
			todosProprietarios: false,
			loading: false,
			done: false,
			tableDataLoading: true,
			tableData: [],
			tableRestricoes: [],
			mapa1: 123,
			mapa2: 456
		}

	},

	computed: {
		proprietarios: function() {

			return this.imovel.proprietarios.split(',')

		}
	},

	methods: {
		checkRestricao: function({ row, rowIndex }) {

			if(row.areaConflito > 0) {

				return 'warning-row'

			}

		},
		gerarPdf: function() {

			if(this.loading) {

				return

			}

			this.loading = true

			this.$refs.mapaPdf.painelCamadas = false

			var that = this

			this.$refs.mapaPdf.focoMapaImovel()

			leafletImage(that.$refs.mapaPdf.mapa, function(err, canvas) {

				if(err) {

				}

				let imgMapa = canvas.toDataURL('image/png', 1.0)

				ImoveisService.getPdf(that.imovel.id, imgMapa).then(({ data }) => {

					var a = document.createElement('a')
					a.href = 'data:application/octet-stream;base64,' + data
					a.download = that.imovel.codigo + '.pdf'
					document.body.appendChild(a)
					a.click()
					a.remove()

					that.loading = false

				})

			})

		},
		mudarAnoMapa: function(newVal) {

			this.$refs.mapaPdf.layerChange(newVal, true)

		}
	},

	mounted() {

		var that = this

		ImoveisService.getImovel(that.$route.query.idImovel).then(({ data }) => {

			that.imovel = data

			that.done = true

			ImoveisService.getAreasARegularizar(that.$route.query.idImovel).then(({ data }) => {

				that.imovel.areasARegularizar = data

				that.$refs.mapaPrincipal.adicionaCamadasAreasRegularizadas()

				that.$refs.mapaPdf.adicionaCamadasAreasRegularizadas()

				that.tableData.push({
					nome: 'Reserva Legal a Regularizar',
					areaAntropizada: +parseFloat(data.arlEmAreaAntropizada.toFixed(4)) + ' ha',
					areaConsolidada: +parseFloat(data.arlEmAreaConsolidada.toFixed(4)) + ' ha',
					total: +parseFloat(data.arlEmAreaAntropizada + data.arlEmAreaConsolidada).toFixed(4) + ' ha'
				}, {
					nome: 'Área de Preservação Permanente a Recompor',
					areaAntropizada: +parseFloat(data.appEmAreaAntropizada.toFixed(4)) + ' ha',
					areaConsolidada: +parseFloat(data.appEmAreaConsolidada.toFixed(4)) + ' ha',
					total: +parseFloat(data.appEmAreaAntropizada + data.appEmAreaConsolidada).toFixed(4) + ' ha'
				}, {
					nome: 'Área de Uso Restrito a Recompor',
					areaAntropizada: +parseFloat(data.aurEmAreaAntropizada.toFixed(4)) + ' ha',
					areaConsolidada: +parseFloat(data.aurEmAreaConsolidada.toFixed(4)) + ' ha',
					total: +parseFloat(data.aurEmAreaAntropizada + data.aurEmAreaConsolidada).toFixed(4) + ' ha'
				}, {
					nome: 'Áreas desmatadas fora da RL / APP e AUR',
					areaAntropizada: '-',
					areaConsolidada: '-',
					total: +parseFloat(data.areasForaEmAreaAntropizada + data.areasForaEmAreaConsolidada).toFixed(4) + ' ha'
				})

				that.tableDataLoading = false

			}).catch(error => {

				that.loading = false

				that.$notify({
					title: 'Erro ao buscar dados do imóvel',
					message: error,
					type: 'error'
				})

			})

		}).catch(error => {

			that.loading = false

			that.$notify({
				title: 'Erro ao buscar dados do imóvel',
				message: error,
				type: 'error'
			})

		})

		this.$parent.$emit('navBar', true)

		this.$nextTick(function() {

			that.$on('layerChange', this.mudarAnoMapa)

		})

	},

	destroyed() {

		this.$parent.$emit('navBar', false)

	}

}
</script>



// WEBPACK FOOTER //
// src/components/views/DadosImovel.vue